/**
 * otrk-hero.js — Homepage mini-customizer + product swap cards
 *
 * Three preview products:
 *   t32-black  Tumbler 32oz Black (default)  — L1 + L2, steel overlay
 *   t24-red    Tumbler 24oz Red (card 1)     — L1 + L2, steel overlay
 *   sign-pine  Pine Sign 10×10 (card 2, temp) — L1 + L2, wood overlay, CSS blank
 *
 * On "View Product": builds /products/{handle}?variant={id}&_hero_design=&_hero_line1=&_hero_line2=
 * product-customizer.js reads those params on the product page and pre-fills.
 */
(function () {
  'use strict';

  // ── Zone configs (set by zone-configs.js, loaded before this script) ──
  var ZONE_CONFIGS = (typeof window !== 'undefined' && window.OTRK_ZONE_CONFIGS) || {};

  // ── 4 featured designs — dictated presets for the hero teaser. Every one is PRODUCTION-COMPATIBLE:
  // its gallery svg_url is a real vector .svg, so an order for it flows through /engrave-vector to a
  // laser file. (The iconic patriotic/automotive clip-art was raster PNG/JPG — not producible by the
  // vector pipeline — and is being pruned from the gallery.) Drawn from the tumbler's own live gallery
  // so the slugs match for _hero_design pre-fill. Uses the transparent designs-processed PNGs for the
  // chip + overlay (filter-friendly); the design still engraves from its vector svg_url in production.
  var CDN_DESIGN = 'https://pub-fa84c12911864d058bc1802111abd316.r2.dev/otrk/designs-processed/';
  var HERO_DESIGNS = [
    {
      // Veteran-owned brand hero (swapped in for ford-shelby, which was pulled from the galleries).
      // Sourced from the current images.xops360 catalog vector .svg. NOTE: not in the legacy tumbler
      // gallery, so click-through pre-fill won't pre-select it until the gallery is rebuilt from the
      // catalog — fine as a teaser. Swap the slug + hash below for any Veteran design you prefer.
      slug: 'proud-army-veteran',
      label: 'Proud Veteran',
      thumbnail: 'https://images.xops360.com/cdn/otrk/designs/1a11cf612a5cfc29e4d46e614cbace644e0974bc9aab8efe9b9fbab24f1e0992.svg',
      img:       'https://images.xops360.com/cdn/otrk/designs/1a11cf612a5cfc29e4d46e614cbace644e0974bc9aab8efe9b9fbab24f1e0992.svg'
    },
    {
      slug: 'farm-fresh-eggs',
      label: 'Farm Fresh',
      thumbnail: CDN_DESIGN + 'funny/farm-fresh-eggs.png',
      img:       CDN_DESIGN + 'funny/farm-fresh-eggs.png'
    },
    {
      slug: 'chicken-mama-1',
      label: 'Chicken Mama',
      thumbnail: CDN_DESIGN + 'funny/chicken-mama-1.png',
      img:       CDN_DESIGN + 'funny/chicken-mama-1.png'
    },
    {
      slug: 'all-you-need-is-love',
      label: 'All You Need',
      thumbnail: CDN_DESIGN + 'funny/all-you-need-is-love.png',
      img:       CDN_DESIGN + 'funny/all-you-need-is-love.png'
    }
  ];

  // ── Product configs ──
  var HERO_PRODUCTS = {
    't32-black': {
      id: 't32-black',
      label: 'Tumbler 32oz',
      price: '$39.99',
      blankUrl: 'https://cdn.shopify.com/s/files/1/0785/8139/9783/files/tumbler-32oz-black_a3ff2513-d997-4488-81ff-89e5a9cc7f73.png',
      zoneKey: 'tumbler-32oz',
      material: 'steel',
      textMode: 'dual',
      productHandle: 'custom-laser-engraved-tumbler-personalized',
      variantId: '52200885813479'
    },
    't24-red': {
      id: 't24-red',
      label: 'Tumbler 24oz',
      price: '$29.99',
      blankUrl: 'https://cdn.shopify.com/s/files/1/0785/8139/9783/files/tumbler-24oz-red_4102df7c-b227-419d-b91c-898530054659.png',
      zoneKey: 'tumbler-24oz',
      material: 'steel',
      textMode: 'dual',
      productHandle: 'custom-laser-engraved-tumbler-personalized',
      variantId: '52200885616871'
    },
    'sign-pine': {
      id: 'sign-pine',
      label: 'Sunshine Sign 10\u00d710',
      price: 'from $29.99',
      blankUrl: 'https://images.xops360.com/cdn/otrk/blanks/pine-square-12x12.png',
      zoneKey: 'wood-square-10x10',
      material: 'wood',
      textMode: 'dual',
      productHandle: 'sunshine-in-my-pocket-sign-1',
      variantId: '52281306710247',
      // LOCKED design (see DESIGN-MODE-SPEC): this product IS the Sunshine design; the customer only
      // adds text. The design is pinned in the preview and the shared gallery is hidden for this card.
      locked: true,
      design: {
        slug: 'sunshine-in-my-pocket',
        label: 'Sunshine In My Pocket',
        thumbnail: 'https://images.xops360.com/cdn/otrk/designs/2ef187749284dc20adfdfd88f0b7b445d948ad2dd2c79e181c100de0994cb076.svg',
        img: 'https://images.xops360.com/cdn/otrk/designs/2ef187749284dc20adfdfd88f0b7b445d948ad2dd2c79e181c100de0994cb076.svg'
      }
    }
  };

  // ── State ──
  var state = {
    currentProduct: HERO_PRODUCTS['t32-black'],
    selectedDesign: null,
    line1: '',
    line2: ''
  };

  // ── DOM refs ──
  var galleryEl     = document.getElementById('otrk-hero-gallery');
  var blankWrap     = document.getElementById('otrk-hero-blank-wrap');
  var blankImg      = document.getElementById('otrk-hero-blank-img');
  var overlayEl     = document.getElementById('otrk-hero-overlay');
  var designImg     = document.getElementById('otrk-hero-design-img');
  var textWrap      = document.getElementById('otrk-hero-text-wrap');
  var line1Preview  = document.getElementById('otrk-hero-line1-preview');
  var line2Preview  = document.getElementById('otrk-hero-line2-preview');
  var line1Input    = document.getElementById('otrk-hero-line1');
  var line2Input    = document.getElementById('otrk-hero-line2');
  var line2Label    = document.getElementById('otrk-hero-l2-label');
  var ctaEl         = document.getElementById('otrk-hero-cta');
  var previewNameEl = document.getElementById('otrk-preview-name');
  var cardEls       = document.querySelectorAll('.otrk-hero-card');

  // ── Update a card element to represent a different product ──
  function updateCardContent(card, product) {
    card.dataset.productId = product.id;
    card.setAttribute('aria-label', 'Preview ' + product.label);

    var imgEl = card.querySelector('.otrk-hero-card__img');
    if (imgEl) {
      if (product.blankUrl) {
        if (imgEl.tagName === 'IMG') {
          imgEl.src = product.blankUrl;
          imgEl.alt = product.label + ' \u2014 blank';
        } else {
          var newImg = document.createElement('img');
          newImg.src = product.blankUrl;
          newImg.alt = product.label + ' \u2014 blank';
          newImg.className = 'otrk-hero-card__img';
          newImg.loading = 'lazy';
          newImg.width = 200;
          newImg.height = 200;
          imgEl.parentNode.replaceChild(newImg, imgEl);
        }
      } else {
        if (imgEl.tagName === 'IMG') {
          var newDiv = document.createElement('div');
          newDiv.className = 'otrk-hero-card__img otrk-hero-card__img--wood-fallback';
          newDiv.setAttribute('role', 'img');
          newDiv.setAttribute('aria-label', product.label + ' blank');
          imgEl.parentNode.replaceChild(newDiv, imgEl);
        } else {
          imgEl.setAttribute('aria-label', product.label + ' blank');
        }
      }
    }

    var nameEl = card.querySelector('.otrk-hero-card__name');
    if (nameEl) nameEl.textContent = product.label;

    var priceEl = card.querySelector('.otrk-hero-card__price');
    if (priceEl) priceEl.textContent = product.price;

    card.classList.remove('otrk-hero-card--active');
  }

  // ── Load a product into the preview panel ──
  function loadHeroProduct(productId) {
    var product = HERO_PRODUCTS[productId];
    if (!product || product.id === state.currentProduct.id) return;

    // Remember which product is leaving the preview before state changes
    var outgoingProductId = state.currentProduct.id;

    // Preserve text state across swaps
    if (line1Input) state.line1 = line1Input.value;
    if (line2Input) state.line2 = line2Input.value;

    state.currentProduct = product;
    // Locked product carries a pinned design; library/plain products reset to no selection.
    state.selectedDesign = (product.locked && product.design) ? product.design : null;

    // Swap blank image or show CSS fallback
    if (blankImg && blankWrap) {
      if (product.blankUrl) {
        blankImg.src = product.blankUrl;
        blankImg.alt = product.label + ' \u2014 blank';
        blankImg.hidden = false;
        blankWrap.classList.remove('otrk-hero-blank--css-fallback');
      } else {
        blankImg.hidden = true;
        blankWrap.classList.add('otrk-hero-blank--css-fallback');
      }
    }

    // Update label and material class on overlay
    if (previewNameEl) previewNameEl.textContent = product.label;
    applyMaterialClass(product.material);

    // Show/hide L2
    updateL2Visibility();

    // Restore text inputs after L2 visibility (which may clear line2 on textMode:single)
    if (line1Input) line1Input.value = state.line1;
    if (line2Input && product.textMode === 'dual') line2Input.value = state.line2;

    // Reset gallery selection + re-render
    renderGallery();

    // Apply zone coords
    applyZoneConfig();

    // Render preview (text carries over)
    renderPreview();

    // Update CTA
    updateCta();

    // Swap: the clicked card now shows the outgoing product (the one that was in preview)
    cardEls.forEach(function (card) {
      if (card.dataset.productId === productId) {
        updateCardContent(card, HERO_PRODUCTS[outgoingProductId]);
      } else {
        card.classList.remove('otrk-hero-card--active');
      }
    });
  }

  // ── Zone positioning ──
  function detectMode() {
    var hasDesign = !!state.selectedDesign;
    var l1 = line1Input ? line1Input.value.trim() : state.line1.trim();
    var l2 = (line2Input && state.currentProduct.textMode === 'dual') ? line2Input.value.trim() : '';
    var hasText = !!(l1 || l2);
    if (hasDesign && hasText) return 'with-text';
    if (hasDesign) return 'design-only';
    if (hasText) return 'text-only';
    return 'design-only';
  }

  function applyZoneConfig() {
    if (!overlayEl) return;
    var product = state.currentProduct;
    var configs = ZONE_CONFIGS[product.zoneKey];
    if (!configs) return;

    var mode = detectMode();
    var config = configs[mode] || configs['design-only'];
    if (!config) return;

    var dz = config.engrave || null;
    var tz = config.text || null;

    // Borrow text-only zone when with-text has no calibrated text zone
    if (mode === 'with-text' && !tz) {
      var textOnly = configs['text-only'];
      if (textOnly) tz = textOnly.text;
    }
    if (!tz && dz) tz = dz;

    if (dz) {
      overlayEl.style.setProperty('--design-top',    dz.top    + '%');
      overlayEl.style.setProperty('--design-left',   dz.left   + '%');
      overlayEl.style.setProperty('--design-width',  dz.width  + '%');
      overlayEl.style.setProperty('--design-height', dz.height + '%');
    }
    if (tz) {
      overlayEl.style.setProperty('--text-top',    tz.top    + '%');
      overlayEl.style.setProperty('--text-left',   tz.left   + '%');
      overlayEl.style.setProperty('--text-width',  tz.width  + '%');
      overlayEl.style.setProperty('--text-height', tz.height + '%');
    }
  }

  // ── Material class on the overlay ──
  function applyMaterialClass(material) {
    if (!overlayEl) return;
    overlayEl.classList.remove('otrk-preview--steel', 'otrk-preview--wood',
                               'otrk-preview--glass', 'otrk-preview--slate');
    if (material && material !== 'wood') {
      overlayEl.classList.add('otrk-preview--' + material);
    }
  }

  // ── Gallery render ──
  function renderGallery() {
    if (!galleryEl) return;
    galleryEl.innerHTML = '';
    // Locked product = pre-selected design: hide the shared 4-design gallery (the customer can't swap
    // the design, they only add text). Library/plain products show the browsable gallery.
    if (state.currentProduct.locked) {
      galleryEl.hidden = true;
      return;
    }
    galleryEl.hidden = false;
    HERO_DESIGNS.forEach(function (design) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'otrk-hero-gallery__item';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-label', design.label);
      btn.dataset.slug = design.slug;

      var img = document.createElement('img');
      img.src = design.thumbnail;
      img.alt = design.label;
      img.loading = 'lazy';
      img.width = 80;
      img.height = 80;
      btn.appendChild(img);

      var lbl = document.createElement('span');
      lbl.textContent = design.label;
      btn.appendChild(lbl);

      btn.addEventListener('click', function () {
        if (state.selectedDesign && state.selectedDesign.slug === design.slug) {
          // Deselect
          state.selectedDesign = null;
          btn.setAttribute('aria-checked', 'false');
          btn.classList.remove('otrk-hero-gallery__item--selected');
        } else {
          state.selectedDesign = design;
          galleryEl.querySelectorAll('.otrk-hero-gallery__item').forEach(function (b) {
            b.setAttribute('aria-checked', 'false');
            b.classList.remove('otrk-hero-gallery__item--selected');
          });
          btn.setAttribute('aria-checked', 'true');
          btn.classList.add('otrk-hero-gallery__item--selected');
        }
        applyZoneConfig();
        renderPreview();
        updateCta();
      });

      galleryEl.appendChild(btn);
    });
  }

  // ── Preview render ──
  function renderPreview() {
    // Design image
    if (designImg) {
      if (state.selectedDesign) {
        designImg.src = state.selectedDesign.img;
        designImg.hidden = false;
      } else {
        designImg.src = '';
        designImg.hidden = true;
      }
    }

    // Text
    var l1 = line1Input ? line1Input.value.trim() : state.line1.trim();
    var l2 = (line2Input && state.currentProduct.textMode === 'dual') ? line2Input.value.trim() : '';
    var hasText = !!(l1 || l2);

    if (textWrap) textWrap.hidden = !hasText;
    if (line1Preview) line1Preview.textContent = l1;
    if (line2Preview) {
      line2Preview.textContent = l2;
      line2Preview.hidden = !l2;
    }

    if (hasText) scheduleFit();
  }

  // ── Text fit engine (horizontal-only in hero) ──
  var fitTimer = null;
  function scheduleFit() {
    if (fitTimer) clearTimeout(fitTimer);
    fitTimer = setTimeout(fitText, 30);
  }

  function fitText() {
    if (!textWrap || textWrap.hidden || !overlayEl) return;
    var textZoneEl = overlayEl.querySelector('.otrk-preview__text-zone');
    if (!textZoneEl) return;
    var zoneRect = textZoneEl.getBoundingClientRect();
    if (zoneRect.width < 2 || zoneRect.height < 2) return;

    textWrap.style.transform = 'none';
    var natural = textWrap.getBoundingClientRect();
    if (natural.width < 1 || natural.height < 1) return;

    var scale = Math.min(
      (zoneRect.width  * 0.9) / natural.width,
      (zoneRect.height * 0.9) / natural.height
    );
    var maxScale = zoneRect.height / 16;
    if (maxScale < 1) maxScale = 1;
    if (scale > maxScale) scale = maxScale;
    if (scale <= 0) scale = 0.1;

    textWrap.style.transform = 'scale(' + scale.toFixed(4) + ')';
  }

  // ── L2 visibility ──
  function updateL2Visibility() {
    var show = state.currentProduct.textMode === 'dual';
    if (line2Input) {
      line2Input.hidden = !show;
      if (!show) { line2Input.value = ''; state.line2 = ''; }
    }
    if (line2Label) line2Label.hidden = !show;
  }

  // ── CTA URL ──
  function updateCta() {
    if (!ctaEl) return;
    var product = state.currentProduct;
    var url = '/products/' + product.productHandle + '?variant=' + product.variantId;
    if (state.selectedDesign) {
      url += '&_hero_design=' + encodeURIComponent(state.selectedDesign.slug);
    }
    var l1 = line1Input ? line1Input.value.trim() : '';
    var l2 = (line2Input && product.textMode === 'dual') ? line2Input.value.trim() : '';
    if (l1) url += '&_hero_line1=' + encodeURIComponent(l1);
    if (l2) url += '&_hero_line2=' + encodeURIComponent(l2);
    ctaEl.href = url;
  }

  // ── Input event wiring ──
  function initInputs() {
    if (line1Input) {
      line1Input.addEventListener('input', function () {
        state.line1 = this.value;
        applyZoneConfig();
        renderPreview();
        updateCta();
      });
    }
    if (line2Input) {
      line2Input.addEventListener('input', function () {
        state.line2 = this.value;
        applyZoneConfig();
        renderPreview();
        updateCta();
      });
    }
  }

  // ── Card click wiring ──
  function initCards() {
    cardEls.forEach(function (card) {
      card.addEventListener('click', function () {
        loadHeroProduct(this.dataset.productId);
      });
    });
  }

  // ── Dynamic delivery date ──
  function updateDeliveryDate() {
    var el = document.getElementById('otrk-delivery-date');
    if (!el) return;
    var d = new Date();
    var count = 0;
    while (count < 5) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) count++;
    }
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    el.textContent = months[d.getMonth()] + ' ' + d.getDate();
  }

  // ── Star parallax ──
  function initStarParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var heroSection = document.getElementById('otrk-hero-stars');
    if (!heroSection) return;
    document.addEventListener('scroll', function () {
      var scrollY = window.pageYOffset;
      heroSection.querySelectorAll('.otrk-star-field svg, .otrk-halo-layer svg').forEach(function (svg) {
        svg.style.transform = 'translate(-50%, calc(-50% + ' + (scrollY * 0.08) + 'px))';
      });
    }, { passive: true });
  }

  // ── Re-fit on resize ──
  function initResizeFit() {
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        applyZoneConfig();
        scheduleFit();
      }, 150);
    }, { passive: true });
  }

  // ── Re-apply zones after blank image loads ──
  function initBlankImageLoad() {
    if (!blankImg) return;
    if (blankImg.complete && blankImg.naturalWidth) {
      applyZoneConfig();
      scheduleFit();
    } else {
      blankImg.addEventListener('load', function () {
        applyZoneConfig();
        scheduleFit();
      });
    }
  }

  // ── Init ──
  function init() {
    if (!document.getElementById('otrk-hero-preview')) return;

    applyMaterialClass(state.currentProduct.material);
    renderGallery();
    applyZoneConfig();
    renderPreview();
    updateL2Visibility();
    updateCta();

    initInputs();
    initCards();
    initBlankImageLoad();
    initResizeFit();
    updateDeliveryDate();
    initStarParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
